export const ACTIONS = {
    click: 'click on button',
    activation: 'plus activation',
};

export const CREATED_VALUE = -1;
export const YANDEX_TRIAL_DURATION = 1;
export const BALANCE_ERROR_CODE = 0;
export const FIRST_TRIAL_DESC = 'Для тех, кто хочет только попробовать и узнать про возможности.';
export const SECOND_TRIAL_DESC = 'Смотрите все каналы из списка со скидкой 10% в течении 90 дней.';
export const MOBILE_TYPE_ID = 2;

export const INITIAL_RESULT = {
    hasResult: false,
    isSuccess: false,
    title: '',
    message: '',
    status: '',
    btnText: '',
};

